import { useState } from 'react';
import CentreViewContainer from './CentreViewContainer';
import { CentreBase, ConsortiumCentres, ModeratorInfo } from '@cambridgeassessment/lib-ee-commons';
import { PostResultsParams } from '../../../../types/PostResults';
import { Tab, Tabs } from '@cambridgeassessment/cambridge-ui';
import { StyledFlexContainer } from '../../ConsortiaManagement/ConsortiaManagement.styles';
import { StyledTextContainer } from '../../ConsortiaManagement/components/ConsortiumCard.styles';

interface Props {
  queryParams: PostResultsParams;
  centre?: CentreBase[];
  consortium?: ConsortiumCentres;
  moderators: ModeratorInfo[];
  allocatedModerator?: ModeratorInfo;
}

const views = [
  { name: 'Centres/consortia', qaId: 'post-results-centres-consortia-tab' },
  { name: 'Upload documents', qaId: 'post-results-upload-documents-tab' },
];

const CentreCardContent = (props: Props): JSX.Element => {
  const { centre, consortium, moderators, allocatedModerator, queryParams } = props;
  const [tabIndex, setTabIndex] = useState(0);
  const handleViewChange = (_event: unknown, tabIndexValue: number) => {
    setTabIndex(tabIndexValue);
  };

  return (
    <>
      <StyledFlexContainer>
        <StyledTextContainer>View:</StyledTextContainer>
        <Tabs value={tabIndex} onChange={handleViewChange}>
          {views.map((view, index) => (
            <Tab key={index} qaId={view.qaId} label={view.name}></Tab>
          ))}
        </Tabs>
      </StyledFlexContainer>
      {tabIndex === 0 && (
        <CentreViewContainer
          moderators={moderators}
          allocatedModerator={allocatedModerator}
          centre={centre}
          consortium={consortium}
          queryParams={queryParams}
        />
      )}
    </>
  );
};

export default CentreCardContent;
